import { CardPackSlot } from './CardPackSlot';
import './CardPackSlots.css';

export function CardPackSlots() {
  return (
    <div className="card-pack-slots">
      <h3 className="card-pack-slots__title">보상 카드팩</h3>
      <div className="card-pack-slots__grid">
        {[1, 2, 3, 4].map((id) => (
          <CardPackSlot key={id} />
        ))}
      </div>
    </div>
  );
}

